<template>
  <!--  <vs-row vs-w="12" class="height-full-screen">-->
  <!--    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12"-->
  <!--            class="bg-white-gradient">-->
  <!--      hi-->
  <!--    </vs-col>-->
  <!--    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12"-->
  <!--            class="bg-white-gradient">-->
  <!--      hi-->
  <!--    </vs-col>-->
  <!--    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12"-->
  <!--            class="bg-white-gradient">-->
  <!--      hi-->
  <!--    </vs-col>-->
  <!--  </vs-row>-->

  <div>
    <div class="container height-full-screen how-it-works-wrapper">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/1 lg:w-1/1 how-it-works-question">
          <h1 class="text-center ">Jak to działa?</h1>
        </div>
      </div>
      <div class="vx-row row-center">


        <template v-for="i in [0,1,2]">
          <vx-card>
            <div ref="img" class="responsive rounded-lg how-it-works-animation"/>
            <div class="my-0">
              <h2 class="text-center" style="margin-bottom: 4rem;">{{content.cards[i].title}}</h2>
            </div>

          </vx-card>
          <div v-if="i < 2" class="mx-2">

            <vs-icon icon="arrow_right_alt" size="75px" color="#7372da"></vs-icon>

          </div>
        </template>

        <!-- CONTENT CARD - PROGRESS BAR/GOAL -->
      </div>
    </div>
  </div>

</template>

<script>
  import lottie from 'lottie-web';

  export default {
    name: "ServiceDescription",
    mounted() {
      const images = this.$refs.img;

      this.content.cards.forEach((card, index) => {
        const animation = lottie.loadAnimation({
          container: images[index], // the dom element that will contain the animation
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: card.animation, // the path to the animation json
          rendererSettings: {
            className: 'some-css-class-name'
          }
        });
        animation.setSpeed(0.4)
      });


    },
    computed: {
      content() {
        return {
          cards: [
            {
              title: 'Przesyłasz skany umowy kredytowej i dane kontaktowe do systemu przygotowanego przez kancelarie adwokacką.',
              animation: 'https://maxst.icons8.com/vue-static/landings/animated-icons/icons/portrait_mode_scanning/portrait_mode_scanning.json'
            },
            {
              title: 'Algorytm oparty na bazie sztucznej inteligencji bada Twoją umowę pod kątem zapisów niezgodnych z prawem.',
              animation: 'https://maxst.icons8.com/vue-static/landings/animated-icons/icons/tune/tune.json'
            },
            {
              title: 'Po chwili otrzymujesz raport zawierający informacje o klauzulach niedozwolonych w twoim dokumencie.',
              animation: 'https://maxst.icons8.com/vue-static/landings/animated-icons/icons/gift-heart/gift-heart.json'
            }
          ]
        }
      }
    }
  }
</script>

<style>
  .how-it-works-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .how-it-works-question {
    height: 10vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }



  .how-it-works-question > h1 {
    transition: 0.3s;
    font-size: 4rem;
    /*font-weight: 300;*/
    border-top: 1px transparent solid;
    border-bottom: 1px transparent solid;

  }

  .how-it-works-steps {
    height: 60vh;
    display: flex;
    align-items: center;
    transition: 0.3s;
  }

  .how-it-works-steps h2 {
    font-weight: 400;
  }

  .how-it-works-steps:hover {
    opacity: 0.9;
  }

  .how-it-works-steps > .vx-card:hover {
    margin-bottom: 30px;
  }

  .how-it-works-animation {
    padding: 4em 4em 2em;
  }

  .row-center {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

</style>
